import React, { useContext, useEffect, useState } from "react";
import { Mention, MentionsInput } from "react-mentions";
import { AppContext } from "../../context/AppContext";
import { notifySuccess } from "../../toaster/notify";

export default function Mesnsion({
  setEmogi,
  replyTo,
  uploadedFiles,
  setUploadedFiles,
  message,
  setMessage,
  setMenstionedUsers,
  menstionedUsers,
  inputRef,
  recentChats,
  setRecentChats,
  pinnedChats,
  setPinnedChats,
  activeChat,
}) {
  const {
    userTyping,
    membersArray,
    setMembersArray,
    sendMessage,
    currentSChannel,
    socket,
    userData,
  } = useContext(AppContext);

  const mentionMembers = membersArray
    .filter((user) => Number(userData.EmpId) !== user.User_Id)
    .map((user) => {
      return {
        id: user?.User_Id,
        display: user?.FirstName + " " + user?.LastName,
      };
    });
  // menstionedUsers

  const typing = () => {
    if (currentSChannel) {
      console.log(localStorage.getItem("Username"));
      socket &&
        socket.emit("typing", {
          schannel_id: currentSChannel,
          FirstName: userData?.FirstName,
          LastName: userData?.LastName,
          name: userData?.Username,
          EmpId: userData?.EmpId,
        });
    }
  };
  const stopTyping = () => {
    if (currentSChannel)
      socket &&
        socket.emit("stoptyping", {
          schannel_id: currentSChannel,
        });
  };
  useEffect(() => {
    let timout = setTimeout(() => {
      stopTyping();
    }, 2000);
    return () => {
      clearTimeout(timout);
    };
  }, [message, socket]);

  // Clipboard paste → upload tray. Mirrors the drag-and-drop and SpeedDial
  // upload flows: anything we accept here lands in `uploadedFiles`, which the
  // composer/UploadTray already render and send. Plain-text pastes fall
  // through untouched (no preventDefault) so users keep normal copy/paste of
  // message content.
  const handlePaste = (e) => {
    const clipboardData = e.clipboardData;
    if (!clipboardData || !clipboardData.items) return;

    const fileItems = Array.from(clipboardData.items).filter(
      (item) => item && item.kind === "file"
    );
    if (fileItems.length === 0) return;

    const files = fileItems
      .map((item) => item.getAsFile())
      .filter(Boolean);
    if (!files.length) return;

    // Browsers hand pasted screenshots over as anonymous "image.png" — stamp
    // a unique name so the upload tray distinguishes consecutive pastes and
    // the multer/S3 layer doesn't see name collisions.
    const stamped = files.map((file) => {
      const isAnon = !file.name || /^image\.(png|jpe?g|gif|webp|bmp)$/i.test(file.name);
      if (!isAnon) return file;
      const ext = (file.type && file.type.split("/")[1]) || "png";
      const unique = `pasted-${Date.now()}-${Math.floor(Math.random() * 1000)}.${ext}`;
      return new File([file], unique, { type: file.type || "image/png" });
    });

    e.preventDefault();
    setUploadedFiles((prev) => [...(prev || []), ...stamped]);
    const isImageOnly = stamped.every((f) => (f.type || "").startsWith("image/"));
    notifySuccess(
      stamped.length === 1
        ? isImageOnly
          ? "Image added from clipboard"
          : "File added from clipboard"
        : `${stamped.length} files added from clipboard`
    );
  };

  return (
    <>
      <MentionsInput
        inputRef={inputRef}
        id="mentionInput"
        className="form-data"
        value={message}
        onChange={(e) => {
          setMessage(e.target.value);
        }}
        placeholder={"Type a message here Or Mention people using '@'"}
        a11ySuggestionsListLabel={"Suggested mentions"}
        allowSpaceInQuery={true}
        onBlur={stopTyping}
        onPaste={handlePaste}
        spellCheck={true}
        onKeyUp={(e) => {
          typing();
          setEmogi(false);
          if (e.key === 13 && !e.shiftKey) {
            e.preventDefault();
          }
          if (e.key === "Enter" && !e.shiftKey) {
            if (message.trim().length || uploadedFiles.length) {
              setEmogi(false);
              sendMessage(
                message,
                [...uploadedFiles],
                replyTo,
                menstionedUsers
              );
              setUploadedFiles([]);
              setMessage("");
              setMenstionedUsers([]);
            }
          }
        }}
        appendSpaceOnAdd={true}
        allowSuggestionsAboveCursor={true}
        forceSuggestionsAboveCursor={true}
      >
        <Mention
          appendSpaceOnAdd={true}
          onAdd={(selectedUser) => {
            let filterObj =
              mentionMembers &&
              mentionMembers.find((item) => item.id === selectedUser);

            let filterMembersWithoutEveryone =
              mentionMembers &&
              mentionMembers.filter((ele) => ele.id !== "everyone");
            selectedUser === "everyone"
              ? setMenstionedUsers(filterMembersWithoutEveryone)
              : setMenstionedUsers([...menstionedUsers, filterObj]);
          }}
          data={mentionMembers && mentionMembers}
        />
      </MentionsInput>
    </>
  );
}
